<template>
  <header class="main-header">
    <div
      class="hamburger"
      @click="toggleMenu"
    >
      <img
        alt="Meny"
        src="@/assets/images/icons/hamburger.svg"
      >
    </div>
    <RouterLink
      class="logotype-container"
      to="/"
    >
      <EventManagerLogotype :fill-color="selectedTheme.accent.text.hex" />
    </RouterLink>
    <HeaderTitle />

    <div class="create-event">
      <NorticButton
        theme-type="accent-complementary"
        slim
        @click="createEvent"
      >
        Skapa evenemang
      </NorticButton>
    </div>

    <SettingsButtonV2 />
    <div class="divider-container">
      <div class="divider" />
    </div>
    <UserButton />
  </header>
</template>

<script>
import routerUtils from '@/components/common/mixins/routerUtils';
import NorticButton from '@/components/common/button/nortic-button/NorticButton.vue';
import EventManagerLogotype from '@/components/layout/navigation/menu/EventManagerLogotype.vue';
import HeaderTitle from '@/components/layout/header/HeaderTitle.vue';
import SettingsButtonV2 from '@/components/layout/header/menu/views/SettingsButtonV2.vue';
import MutationTypes from '../../../store/constants/mutations';
import UserButton from './menu/UserButton.vue';

export default {
  name: 'Header',
  components: {
    SettingsButtonV2,
    HeaderTitle,
    EventManagerLogotype,
    NorticButton,
    UserButton,
  },
  mixins: [routerUtils],
  data() {
    return {
      isCogCancelling: false,
    };
  },
  methods: {
    toggleMenu() {
      this.$store.commit(MutationTypes.TOGGLE_MENU, true);
    },
    createEvent() {
      this.$router.push(this.getCreateEventRoute());
    },
  },
};
</script>

<style lang="scss" scoped>
  header.main-header {
    display: grid;
    align-items: center;
    position: relative;

    --gradient-color: rgba(var(--accent-bg-rgb), 0.85);

    background: linear-gradient(var(--gradient-color), var(--gradient-color)), url('~@/assets/images/background/trianglify_alt.svg') center center;
    grid-template-rows: 1fr;
    box-shadow: 5px 5px 6px -2px rgba(var(--shadow-color-rgb), 0.5);
    z-index: 2;
    grid-template-columns: 300px 1fr max-content 60px 30px max-content;
    padding: 0 20px;

    @media screen and (max-width: $mediumLargeBreakpoint) {
      grid-template-columns: 80px 1fr max-content 60px 20px max-content;
      padding: 0 20px 0 0;
    }

    @media screen and (max-width: $mediumBreakpoint) {
      grid-template-columns: 80px 1fr 60px 20px max-content;
      padding: 0 20px 0 0;
    }

    @media screen and (max-width: $smallBreakpoint) {
      grid-template-columns: minmax(40px, 60px) 1fr 60px max-content 45px;
      padding: 0 20px 0 0;
    }

    .hamburger {
      cursor: pointer;
      display: none;
      justify-self: center;

      @media screen and (max-width: $mediumLargeBreakpoint) {
        display: block;
      }
    }

    .logotype-container {
      display: block;

      @media screen and (max-width: $mediumLargeBreakpoint) {
        display: none;
      }
    }

    .create-event {
      @media screen and (max-width: $mediumBreakpoint) {
        display: none;
      }

      border-bottom: 1px solid var(--primary-divider-hex);
      display: flex;
      height: calc(100% - 1px);
      align-items: center;
    }

    .divider-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100% - 1px);
      border-bottom: 1px solid var(--primary-divider-hex);

      .divider {
        border-left: 1px solid var(--primary-divider-hex);
        justify-self: center;
        height: 32px;
      }
    }
  }

</style>
